import React from 'react';
import { render } from '@testing-library/react';
import { Drawer } from './Drawer';
import { BodyText } from '../BodyText';
import { Button } from '../Button';

describe('Drawer', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Drawer
				header="Drawer Header"
				open
				footer={
					<>
						<Button className="m-r-2">Cancel</Button>
						<Button primary>Save</Button>
					</>
				}
				backdrop
				data-auto-sel="automation-selector"
			>
				<BodyText className="m-b-2">
					Lorem ipsum dolor sit amet
				</BodyText>
				<BodyText className="m-b-2">
					Lorem ipsum dolor sit amet
				</BodyText>
			</Drawer>
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       Drawer is rendered in a portal
		 */
		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
